/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdetailgallery2Inputs */

const en_eventdetailgallery2 = /** @type {(inputs: Eventdetailgallery2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos`)
};

const de_eventdetailgallery2 = /** @type {(inputs: Eventdetailgallery2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

/**
* | output |
* | --- |
* | "Photos" |
*
* @param {Eventdetailgallery2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdetailgallery2 = /** @type {((inputs?: Eventdetailgallery2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdetailgallery2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdetailgallery2(inputs)
	return de_eventdetailgallery2(inputs)
});
export { eventdetailgallery2 as "eventDetailGallery" }